import { DialogTitle } from "@radix-ui/react-dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import React from "react";
import { Dialog, DialogContent, DialogOverlay } from "@/components/atomic/Dialog";
import { ScrollArea, ScrollBar } from "@/components/atomic/ScrollArea";
import { cn } from "@/lib/utils";

interface VersionModalProps {
  modalOpen: boolean;
  versions: string[];
  setModalOpen: (open: boolean) => void;
}

const VersionModal: React.FC<VersionModalProps> = ({
  modalOpen,
  versions,
  setModalOpen,
}) => {
  return (
    <Dialog open={modalOpen} onOpenChange={setModalOpen}>
      <DialogContent
        className={cn(
          "rounded-[10px] shadow-[0px_0px_10px_0px_rgba(0,0,0,0.25)] p-0 min-w-[800px] min-h-[568px] bg-white",
          "data-[state=closed]:slide-out-to-right-[0] data-[state=open]:slide-in-from-right-[0] z-1001",
        )}
      >
        <VisuallyHidden>
          <DialogTitle>バージョン情報</DialogTitle>
        </VisuallyHidden>
        <button
          data-testid="close-button"
          onClick={() => setModalOpen(false)}
          className="absolute right-4 top-4 w-[40px] h-[40px] bg-[#F3F3F4] rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
          aria-label="Close modal"
        >
          <div className="relative w-4 h-4">
            <div className="absolute top-1/2 left-1/2 w-[20px] h-[3px] bg-[#868e96] transform -translate-x-1/2 -translate-y-1/2 rotate-45" />
            <div className="absolute top-1/2 left-1/2 w-[20px] h-[3px] bg-[#868e96] transform -translate-x-1/2 -translate-y-1/2 -rotate-45" />
          </div>
        </button>
        <div className="my-20 px-20 min-w-[800px] max-h-[568px]">
          <ScrollArea className="h-full">
            {versions.map((version) => (
              <div key={version} className="text-[14px] text-[#333333] pl-4">
                {version}
              </div>
            ))}
            <ScrollBar orientation="vertical" />
          </ScrollArea>
        </div>
      </DialogContent>
      <DialogOverlay className="bg-[rgba(0,0,0,0.4)] z-1000" />
    </Dialog>
  );
};

export default VersionModal;
